<style lang="scss">
.vft-svg-icon{
    display: inline-block;
}
  .icon,
  .svg_icon {
    display: inline-block;
    color: inherit;
    line-height: 1;
  }

  .svg_icon {
    width: 16px;
    height: 16px;
    svg {
      width: 100%;
      height: 100%;
    }
  }

  .svg_icon path,
  .svg_icon use {
    fill: currentColor;
  }
  .svg_icon.icon_back{
      width:24px;
      height: 24px;
  }

</style>

<template>
  <i class="svg_icon" :class="'icon_'+type">
    <svg :class="'svg_icon_'+type">
      <use :xlink:href="'#svg_icon_'+type"></use>
    </svg>
  </i>
</template>

<script>
import SvgIcons from './SvgIcons.svg'
if (typeof document !== 'undefined' && !document.getElementById('SvgIcons')) {
  document.body.insertAdjacentHTML('beforeend', SvgIcons)
}

export default {
  name: 'VftSvgIcons',
  props: {
    type: String
  }
}
</script>
